import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import arrowIcon from '../../assets/images/Arrow.svg';
import "../../styles/dataTable.css";
import searchIcon from '../../assets/images/search_icon.svg';
import editIcon from '../../assets/images/edit_icon.svg';
import StateCityFilter from '../../components/stateCityFilter';

const TotalHajjPackages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const filterType = location.state?.filterType || "";

  const [cards, setCards] = useState([]);

  // ✅ FILTER STATE
  const [filters, setFilters] = useState({
    state: "",
    city: "",
    status: "",
    servicePlan: "",
  });

  // Table state
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  // -------------------- FILTER + SEARCH --------------------
  const filteredData = cards.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];

      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // -------------------- API --------------------
const fetchCards = async () => {
  try {
    const formData = new FormData();

    // ✅ STATUS
    if (filterType === "active") {
      formData.append("status", "1");
    } 
    else if (filterType === "inactive") {
      formData.append("status", "0");
    } 
    else if (filterType === "expired") {
      formData.append("status", "expired"); // 🔥 FIX KEY
    } 

    // ✅ STATE
    if (filters.state) {
      formData.append("state", filters.state);   // 🔥 CHANGE HERE
    }

    // ✅ CITY
    if (filters.city) {
      formData.append("city", filters.city);     // 🔥 CHANGE HERE
    }


    // ✅ STATUS
    if (filters.status) {
      formData.append("status", filters.status);
    }

    // ✅ SERVICE PLAN
    if (filters.servicePlan) {
      formData.append("service_plan", filters.servicePlan);
    }

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await api.post(
      '/dashboard/haajpackgelist',
      formData
    );
    console.log('API Response:', response.data);
    setCards(response.data.data || []);

  } catch (error) {
    console.error('Error fetching card data:', error);
  }
};

  // Initial load
  useEffect(() => {
    fetchCards();
  }, []);

  // -------------------- UI --------------------
  return (
    <div style={{ padding: "20px" }}>

      {/* ✅ FILTER SECTION */}

        <h2 style={{ fontWeight: 700 , marginBottom: "20px"}}>Hajj Package</h2>
         {/* <StateCityFilter onChange={setFilters} fetchCards={fetchCards} />  */}

  

      {/* HEADER */}
      <div className="table-header" style={{display: "flex",flexDirection:'column', justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "0px",flexwrap: "wrap",aligncontent: "stretch", padding: "5px 22px "}}>
            <div style={{display: "flex",  alignSelf: "flex-end",gap:"30px", marginTop: "10px", width: "100%"}}>

        



        <div className="entries-container">
          <label>Show: </label>
          <select
            value={entriesPerPage}
            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          >
            <option value={10}>10 Entries per page</option>
            <option value={50}>50 Entries per page</option>
            <option value={100}>100 Entries per page</option>
          </select>
          </div>

          <div className="search-container">
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            placeholder="search"
          />
          <img src={searchIcon} alt="search-icon" className="search-icon" />
        </div>

        </div>
      </div>


      {/* TABLE */}
      <table width="100%" cellPadding="15" className="table-no-outer-border">
        <thead>
          <tr>
            <th onClick={() => handleSort("packagename")}>Packagename</th>
            <th onClick={() => handleSort("duration")}>Duration</th>
            <th onClick={() => handleSort("price")}>Price</th>
            <th>Image</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((card) => (
              <tr key={card.id}>
                <td>{card.packagename}</td>
                <td>{card.duration}</td>
                <td>₹ {parseFloat(card.price).toLocaleString('en-IN')}</td>
                <td>
                  <img
                    style={{ width: '80px' }}
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${card.image_path}`}
                    alt=""
                  />
                </td>
                <td>
                  {card?.is_approved !== '1' ? "Pending" : "Approved"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
        >
          Prev
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            style={{
              margin: "5px",
              fontWeight: currentPage === page ? "bold" : "normal"
            }}
          >
            {page}
          </button>
        ))}

        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
        >
          Next
        </button>
      </div>

    </div>
  );
};

export default TotalHajjPackages;